import * as React from "react";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import Web3Provider from './providers/web3';
import NotificationProvider from "providers/notification";
import App from "./App";
import theme from "./themes";
import { BASE_PATH } from "./config";
import AOS from 'aos';
import 'aos/dist/aos.css';
import "assets/scss/style.scss";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import "swiper/css/navigation";

AOS.init();

const rootElement = document.getElementById("root");
const root = createRoot(rootElement!);

root.render(
  <BrowserRouter basename={BASE_PATH}>
    <Web3Provider>
      <NotificationProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </NotificationProvider>
    </Web3Provider>
  </BrowserRouter>
);
